import { ArrowIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL } from "../site";

const makeupGallery = [
  { src: "/images/makeup/legacy-makeup-1.jpg", alt: "Before-and-after full-face makeup transformation" },
  { src: "/images/makeup/legacy-makeup-2.jpg", alt: "Formal updo and finished makeup details" },
  { src: "/images/makeup/legacy-makeup-3.jpg", alt: "Special-event eye makeup and finished look" },
  { src: "/images/makeup/legacy-makeup-4.jpg", alt: "Bridal makeup before-and-after details" },
  { src: "/images/makeup/legacy-makeup-5.jpg", alt: "Special-event hair and makeup portfolio collage" },
  { src: "/images/makeup/legacy-makeup-6.jpg", alt: "Before-and-after natural makeup look" },
  { src: "/images/makeup/legacy-makeup-7.jpg", alt: "Artist applying bright pink lip color" },
  { src: "/images/makeup/legacy-makeup-8.jpg", alt: "Makeup artist applying a finished look" },
] as const;

export function MakeupPage() {
  return (
    <>
      <PageHero
        eyebrow="Professional makeup"
        title="Ready for anything."
        description="Flawless makeup does not make the woman, but it can make her feel ready to take on the world. Let our professional artists bring your look together."
        image="/images/makeup-hero.jpg"
      />
      <section className="section makeup-section">
        <div className="container makeup-grid">
          <div className="makeup-copy">
            <p className="eyebrow">All-occasion beauty</p>
            <h2>Polished, dimensional, and made to feel like you.</h2>
            <p>Whether you want an elevated natural look or full evening glamour, your artist will tailor the finish to your features, wardrobe, lighting, and occasion.</p>
            <div className="makeup-prices">
              <div><span>Full-face makeup</span><strong>$70 & up</strong></div>
              <div><span>Eye makeup</span><strong>$40 & up</strong></div>
              <div><span>All-occasion & bridal packages</span><strong>Available</strong></div>
            </div>
            <p className="price-note">Starting prices may vary by artist, products, and the requested look.</p>
            <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">Book your makeup service <ArrowIcon /></a>
          </div>
          <div className="makeup-images" aria-label="Makeup portfolio">
            {makeupGallery.map((image, index) => (
              <figure key={image.src}>
                <img src={image.src} alt={image.alt} loading={index > 3 ? "lazy" : "eager"} decoding="async" />
              </figure>
            ))}
          </div>
        </div>
      </section>
      <section className="simple-cta simple-cta--rose">
        <div className="container simple-cta__inner">
          <div><p className="eyebrow eyebrow--light">Planning a wedding?</p><h2>Combine hair and makeup for the whole party.</h2></div>
          <a className="button button--light" href="/wedding/">Explore wedding services <ArrowIcon /></a>
        </div>
      </section>
    </>
  );
}
